module.exports = __webpack_public_path__ + "static/media/ideal-wero.97b7c674.svg";